import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgProfileFill = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M16.2501 3.67517C13.0209 3.67517 10.3958 6.30037 10.3958 9.52948C10.3958 12.697 12.873 15.2605 16.1022 15.3715C16.2008 15.3591 16.2994 15.3591 16.3733 15.3715C16.398 15.3715 16.4103 15.3715 16.4349 15.3715C16.4473 15.3715 16.4473 15.3715 16.4596 15.3715C19.6147 15.2605 22.092 12.697 22.1044 9.52948C22.1044 6.30037 19.4792 3.67517 16.2501 3.67517Z",
		fill: "white"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M22.511 18.6498C19.0723 16.3574 13.4645 16.3574 10.0012 18.6498C8.43598 19.6974 7.57324 21.1148 7.57324 22.6307C7.57324 24.1467 8.43598 25.5517 9.98891 26.587C11.7144 27.7455 13.9822 28.3248 16.2499 28.3248C18.5177 28.3248 20.7855 27.7455 22.511 26.587C24.0639 25.5394 24.9266 24.1344 24.9266 22.6061C24.9143 21.0901 24.0639 19.6851 22.511 18.6498Z",
		fill: "white"
	})]
});
const ForwardRef = forwardRef(SvgProfileFill);
export default ForwardRef;
